import { render, staticRenderFns } from "./RegisterPromotions.vue?vue&type=template&id=b37e98f0"
import script from "./RegisterPromotions.vue?vue&type=script&lang=js"
export * from "./RegisterPromotions.vue?vue&type=script&lang=js"
import style0 from "./RegisterPromotions.vue?vue&type=style&index=0&id=b37e98f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports